import { HttpClient, httpResource } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { env } from '../../../environments/environment'
import {
  DeadletterContext,
  DeadletterCounter,
  DeadletterMessage,
  DeadletterQueueSummary,
  ResendDeadletterRequest,
  ResendDeadletterResponse,
} from '../model/intern-backend.model'

@Injectable({
  providedIn: 'root',
})
export class DeadletterService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = env().api.internalUrl

  readonly queues = httpResource<DeadletterQueueSummary[]>(() => `${this.apiUrl}/deadletter/queues`)
  readonly openDeadletterCount = httpResource<DeadletterCounter>(() => `${this.apiUrl}/deadletter/counter`)

  getMessages$(topic: string, subscription: string, limit: number) {
    const params = { limit: String(limit) }
    return this.http.get<DeadletterMessage[]>(
      `${this.apiUrl}/deadletter/queues/${encodeURIComponent(topic)}/${encodeURIComponent(subscription)}/messages`,
      { params },
    )
  }

  getContext$(topic: string, subscription: string, sequenceNumber: number) {
    return this.http.get<DeadletterContext>(
      `${this.apiUrl}/deadletter/queues/${encodeURIComponent(topic)}/${encodeURIComponent(subscription)}/messages/${sequenceNumber}/context`,
    )
  }

  resend$(topic: string, subscription: string, sequenceNumber: number, body: ResendDeadletterRequest) {
    return this.http.post<ResendDeadletterResponse>(
      `${this.apiUrl}/deadletter/queues/${encodeURIComponent(topic)}/${encodeURIComponent(subscription)}/messages/${sequenceNumber}/resend`,
      body,
    )
  }

  discard$(topic: string, subscription: string, sequenceNumber: number) {
    return this.http.post<void>(
      `${this.apiUrl}/deadletter/queues/${encodeURIComponent(topic)}/${encodeURIComponent(subscription)}/messages/${sequenceNumber}/discard`,
      {},
    )
  }
}
